import { render } from "./EditAssignation.vue?vue&type=template&id=515e48c6&ts=true"
import script from "./EditAssignation.vue?vue&type=script&lang=ts"
export * from "./EditAssignation.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__